/**
 * asad-shimmer.js
 * Nahhar Fashions — Shimmer skeleton cleanup
 *
 * Handles two cases:
 * 1. Images already cached → fires immediately via the .complete check
 * 2. Images lazy-loaded off-screen → IntersectionObserver triggers load
 */
(function () {
  'use strict';

  function removeShimmer(mediaEl) {
    const container = mediaEl.closest('.asad-product-card__media');
    if (!container) return;
    const shimmer = container.querySelector('.asad-card-shimmer');
    if (shimmer) {
      shimmer.classList.add('asad-card-shimmer--loaded');
    }
  }

  function initShimmers() {
    // Handle all card media elements (img and video)
    const mediaEls = document.querySelectorAll('.asad-card-media');

    mediaEls.forEach(function (el) {
      // Already loaded (cached images)
      if (el.tagName === 'IMG' && el.complete && el.naturalWidth > 0) {
        removeShimmer(el);
        return;
      }
      if (el.tagName === 'VIDEO') {
        // Video: use readyState or poster as fallback
        if (el.readyState >= 2) {
          removeShimmer(el);
          return;
        }
        el.addEventListener('loadeddata', function () { removeShimmer(el); }, { once: true });
        // Fallback: poster image loaded
        if (el.poster) {
          var posterImg = new Image();
          posterImg.onload = function () { removeShimmer(el); };
          posterImg.src = el.poster;
        }
        return;
      }

      // For lazy images not yet loaded — use IntersectionObserver
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var img = entry.target;
              // Force load by removing lazy if needed
              img.addEventListener('load', function () { removeShimmer(img); }, { once: true });
              img.addEventListener('error', function () { removeShimmer(img); }, { once: true });
              observer.unobserve(img);
            }
          });
        }, { rootMargin: '200px' });
        io.observe(el);
      } else {
        // Fallback for old browsers
        el.addEventListener('load', function () { removeShimmer(el); }, { once: true });
        el.addEventListener('error', function () { removeShimmer(el); }, { once: true });
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShimmers);
  } else {
    initShimmers();
  }

  // Re-run after Shopify section re-renders (theme editor live preview)
  document.addEventListener('shopify:section:load', initShimmers);
})();
